export default "/_next/static/fonts/Honey-BoldBanner-bf0a0a940984a91ac5606ab55c29da14.woff2";